import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=e2b42cee&"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js&"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
